import axios from "axios";
import { ConstVariables } from "./ConstantVariables";

export default axios.create({
  baseURL: ConstVariables.CONNECTERE_API,
});
